import React from 'react';
import TriggerWindowFields from './TriggerWindowFields';
import EligibilityConditionsShared from './EligibilityConditionsShared';

const EligibilityConditionsLifecycle = ({ formData, updateField }) => {
  return (
    <div className='eligibility-conditions-view'>
      <TriggerWindowFields formData={formData} updateField={updateField} />
      <EligibilityConditionsShared formData={formData} updateField={updateField} />
    </div>
  );
};

export default EligibilityConditionsLifecycle;
